import React from "react";
import Select from "react-select";
import { SelectionOptionsType } from "../pages/Leaderboard";

interface SelectComponentProps {
  placeholder?: string;
  value: SelectionOptionsType | null | undefined;
  onSelect: (value: SelectionOptionsType | undefined) => void;
  options: SelectionOptionsType[];
  disabled: boolean;
}

export default function SelectComponent({
  placeholder,
  value,
  onSelect,
  options,
  disabled,
}: SelectComponentProps) {
  return (
    <Select
      placeholder={placeholder ?? "Filter"}
      className="z-50 bg-white"
      value={value ? value : null}
      isClearable={true}
      isSearchable={true}
      name="Entrant"
      isDisabled={disabled}
      onChange={onSelect}
      options={options}
      menuPortalTarget={document.body} // Ensures the dropdown renders at the highest level
      styles={{
        menuPortal: (base: any) => ({ ...base, zIndex: 9999 }), // Ensures dropdown is above all elements
        control: (base: any) => ({
          ...base,
          backgroundColor: "white",
        }),
      }}
    />
  );
}
